import { FormlyNgbRatingModule } from '@enauka/shared/ui/formly/ngb-rating';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { FormlyModule } from '@ngx-formly/core';
import { HttpClientModule } from '@angular/common/http';
import { ErrorHandler, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BlockUIConfig, Environment, SharedApplicationModule } from '@enauka/shared/application';
import { AuthServiceConfig } from '@enauka/shared/infrastructure/auth/data-access';
import { GlobalErrorHandler } from '@enauka/shared/infrastructure/error-handling';
import { StronaGlownaModule } from '@enauka/strona-glowna';
import { FormlyBootstrapModule } from '@ngx-formly/bootstrap';
import { BlockUIModule } from 'ng-block-ui';
import { BlockUIHttpModule } from 'ng-block-ui/http';
import { NgxGoogleAnalyticsModule, NgxGoogleAnalyticsRouterModule } from 'ngx-google-analytics';
import { environment } from '../environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FormlyConfig } from '@enauka/shared/ui/formly';
import { FontaAwesomeConfig, FontAwesomeModule } from '@enauka/shared/ui/font-awesome';
const formlyConfig = FormlyConfig.getConfig();
formlyConfig.types.push(FormlyNgbRatingModule.getNgRatingType())

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    AppRoutingModule,
    StronaGlownaModule,
    FormsModule,
    ReactiveFormsModule,
    FormlyBootstrapModule,
    FormlyModule.forRoot(formlyConfig),
    SharedApplicationModule,
    BlockUIModule.forRoot(BlockUIConfig.getConfig()),
    BlockUIHttpModule.forRoot(BlockUIConfig.getHttpConfig()),
    NgxGoogleAnalyticsModule.forRoot('UA-26721012-4'),
    NgxGoogleAnalyticsRouterModule,
    HttpClientModule,
    FontAwesomeModule,
  ],
  providers: [
    { provide: Environment, useValue: environment },
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    { provide: AuthServiceConfig, useValue: { api: "/api", userPrincipal: 'userPrincipal' } },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(library: FaIconLibrary) {
    FontaAwesomeConfig.configure(library);
  }
}
